import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function discountApprovingRoutes($stateProvider: StateProvider) {
    let discountStationListModule: {default: any;};

    $stateProvider
        .state({
            name: 'discount-approving',
            url: '/discount-approving',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => discountStationListModule.default
            },
            lazyLoad: async () => {
                discountStationListModule = await import(/* webpackChunkName: "discount-approving" */ '../KpDiscountApprovingPage.svelte');
                return null;
            }
        });
}